import Close from '@mui/icons-material/Close'
import { DialogContent, IconButton } from '@mui/material'
import { useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import {
  UAPActivityDetailsTertiaryTitle,
  UAPActivityDetailsTitle,
  UAPDayItemEventDetailsContainer,
} from '../../MyPlanStyles'

export function PlannedActivityDetailsComponent({
  activityPlan,
  plannedActivity,
  plannedActivityIndex,
  signedUrls,
  currentDayInMoment,
  closePlannedActivityDetails,
  togglePrewall,
  toggleAppExclusiveModal,
  refreshActivityPlan,
  setMentalStateDialogOpen,
  setMentalStateDialogData,
  setQuoteDialogOpen,
  setQuoteData,
  setupData,
  profileData,
  totalPlannedActivities = 1,
}) {
  const { setJournalData } = useContext(JournalContext)
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const [selectedItem, setSelectedItem] = useState()
  const mainPlannedActivity = plannedActivity?.plannedActivity
  const otherActivities = plannedActivity?.otherActivities
  const { planId: urlPlanId } = useParams()

  const [loadingData, setLoadingData] = useState(false)
  const [markingCompleted, setMarkingCompleted] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const mainActivityCategory = setupData?.metaCategories?.find(
    (cat) => cat?.id === mainPlannedActivity?.metaCategoryId,
  )
  const categoryTypeOfPlannedItem = mainActivityCategory?.categoryType

  function renderActivity(key = plannedActivity?.id, activityObject, isMain = false) {
    const currentMetaCategory = mainActivityCategory

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <UAPDayItemEventDetailsContainer>
          <div className="d-flex flex-column gap-4 w-100">
            <div className="d-flex align-items-center justify-content-between gap-2">
              <UAPActivityDetailsTitle>
                Day {plannedActivity?.planItemIdx + 1} of {totalPlannedActivities}
              </UAPActivityDetailsTitle>
              <IconButton onClick={closePlannedActivityDetails}>
                <Close />
              </IconButton>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex flex-column gap-2 w-100">
                <UAPActivityDetailsTertiaryTitle>
                  {activityObject?.customDescription
                    ? activityObject?.customDescription
                    : activityObject?.descriptionSentence}
                </UAPActivityDetailsTertiaryTitle>
              </div>
            </div>
          </div>
        </UAPDayItemEventDetailsContainer>
      </div>
    )
  }

  return (
    <>
      <DialogContent sx={{ p: 1 }}>
        <div style={{ width: '100%' }}>{renderActivity(undefined, mainPlannedActivity, true)}</div>
      </DialogContent>
    </>
  )
}

/* <UAPActivityDetailsSubTitle className="d-flex align-items-center gap-2">
{(currentMetaCategory?.coverIcon || currentMetaCategory?.iconImage) && (
  <Avatar
    sizes="small"
    sx={{ width: 35, height: 35 }}
    src={getImageLink(
      currentMetaCategory?.iconImage || currentMetaCategory?.coverIcon,
    )}
  >
    <BrokenImage sx={{ fontSize: '18px' }} />
  </Avatar>
)}
<span>
  {activityObject?.customCategoryTitle?.charAt(0)?.toUpperCase() +
    activityObject?.customCategoryTitle?.slice(1)}
</span>
</UAPActivityDetailsSubTitle> */

// const itemData = APItemDataExtractor(plannedActivity, setupData)

// function showActivityDetails(activityObject) {
//   return signedUrls?.signedUrl ? (
//     <ActivityDetailsPlayer>
//       <CustomReactPlayer
//         config={{
//           file: {
//             // forceHLS: true,
//             hlsOptions: {
//               debug: false,
//               xhrSetup: function (xhr, signedURL) {
//                 xhr.setRequestHeader('Authorization', `Bearer ${getAuthToken()}`)
//               },
//               // enableWebVTT: true,
//             },
//           },
//         }}
//         url={`${signedUrls?.signedUrl}`}
//         width={'100%'}
//         height={'100%'}
//       />
//     </ActivityDetailsPlayer>
//   ) : (
//     <APArticleTextContainer>
//       {signedUrls?.content && getParseDataFromHtmlString(signedUrls?.content)}
//     </APArticleTextContainer>
//   )
// }

// async function markActivityAsCompleted() {
//   setMarkingCompleted(true)
//   const response = await putDataWithParams(
//     '/api/secure/user/activity/mark-completed-offline',
//     {},
//     {
//       planId: activityPlan?.id,
//       day: plannedActivityIndex,
//       updateType: AP_REPORT_TYPES.completed,
//       plannedActivityId: plannedActivity?.id,
//     },
//   )
//   if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
//     await refreshActivityPlan()
//     toast.success('Activity marked as completed')
//     closePlannedActivityDetails()
//   } else {
//     toast.error('Error in marking activity as completed')
//   }
//   setMarkingCompleted(false)
// }

// async function takeActionOnStart() {
//   setLoadingData(true)
//   // Getting Data about activity

//   // await startActivity(
//   //   categoryTypeOfPlannedItem,
//   //   plannedActivity?.id,
//   //   mainPlannedActivity?.activityId,
//   //   { setJournalData, navigate, urlPlanId, refreshActivityPlan },
//   // )

//   let response
//   if (categoryTypeOfPlannedItem === 'article') {
//     response = await getFeatureItemBySlug('article', mainPlannedActivity?.activityId, false)
//     if (response.status === 200 && isCommonResponseSuccessful(response.data.code)) {
//       response = { data: response?.data?.data?.article, status: 200 }
//     } else {
//       response = { data: null, status: 500 }
//     }
//   } else if (categoryTypeOfPlannedItem === 'assessment') {
//     response = await getAssessmentData(mainPlannedActivity?.activityId, false)
//   } else if (categoryTypeOfPlannedItem === 'journal') {
//     response = await getJournalDataBySlug(mainPlannedActivity?.activityId, false)
//   } else if (categoryTypeOfPlannedItem === 'quotes') {
//     response = await getQuoteData(mainPlannedActivity?.activityId, false)
//   } else if (categoryTypeOfPlannedItem === 'course') {
//     if (mainPlannedActivity?.customFields?.courseId) {
//       response = await getCourseData(
//         mainPlannedActivity?.customFields?.courseId,
//         mainPlannedActivity?.activityId,
//       )
//     }
//   } else if (categoryTypeOfPlannedItem === 'mentalStateType') {
//     response = await getMentalStateType(mainPlannedActivity?.activityId)
//   } else if (categoryTypeOfPlannedItem === 'practice') {
//     response = await getPracticeTimerById(mainPlannedActivity?.activityId)
//   }
//   setLoadingData(false)
//   closePlannedActivityDetails()
//   await sleep(200)

//   // After API data about activity
//   if (response?.status === 200) {
//     if (
//       isUserAllowedToAccessContent(
//         profileData?.subscriptionTypeId,
//         categoryTypeOfPlannedItem === 'course'
//           ? response?.data?.course?.subscription?.id
//           : response?.data?.subscription?.id,
//       )
//     ) {
//       if (categoryTypeOfPlannedItem === 'article') {
//         closePlannedActivityDetails()
//         dispatch({
//           type: 'set',
//           articleGoBackState: {
//             onClick: () => navigate(`/my-activity/${urlPlanId}`),
//             text: 'Go Back to plan page',
//           },
//         })
//         navigate(
//           `/article/id/${mainPlannedActivity?.activityId}?src=planned-activity&src-id=${plannedActivity?.id}`,
//           {
//             state: {
//               passedArticleData: response?.data,
//             },
//           },
//         )
//       } else if (categoryTypeOfPlannedItem === 'assessment') {
//         closePlannedActivityDetails()
//         dispatch({
//           type: 'set',
//           assessmentGoBackState: {
//             onClick: () => navigate(`/my-activity/${urlPlanId}`),
//             text: 'Go Back to plan page',
//           },
//         })
//         navigate(
//           `/assessment/id/${mainPlannedActivity?.activityId}?src=planned-activity&src-id=${plannedActivity?.id}`,
//           {
//             state: {
//               passedAssessmentData: response?.data,
//             },
//           },
//         )
//       } else if (categoryTypeOfPlannedItem === 'journal') {
//         setJournalData({
//           showJournal: true,
//           callSource: 'tilespage',
//           data: {
//             ...response?.data,
//             callSourceId: plannedActivity?.id,
//             sourceName: 'planned-activity',
//           },
//           pageState: '',
//           subscription: '',
//           afterSubmitFunction: refreshActivityPlan,
//         })
//       } else if (categoryTypeOfPlannedItem === 'course') {
//         setPlayerData({
//           ...resetPlayerData(playerData),
//           showPlayer: true,
//           selectedCard: playerData.showPIP
//             ? playerData?.selectedCard
//             : getPlayerDataForActivity(
//                 response?.data?.course,
//                 response?.data?.teacher,
//                 mainPlannedActivity?.activityId,
//               ),
//           afterRatingFunction: refreshActivityPlan,
//           source: 'planned-activity',
//           id: plannedActivity?.id,
//         })
//       } else if (categoryTypeOfPlannedItem === 'mentalStateType') {
//         setMentalStateDialogOpen(true)
//         setMentalStateDialogData({
//           ...response?.data,
//           // options: mentalStateTypesOptions,
//           src: 'planned-activity',
//           srcId: plannedActivity?.id,
//         })
//       } else if (categoryTypeOfPlannedItem === 'quotes') {
//         setQuoteData({
//           ...response?.data,
//           src: 'planned-activity',
//           srcId: plannedActivity?.id,
//           showCongratulatoryMessage: false,
//         })
//         await sleep(200)
//         setQuoteDialogOpen(true)
//       } else if (categoryTypeOfPlannedItem === 'practice') {
//         navigate(
//           `/timer/i/${mainPlannedActivity?.activityId}?src=planned-activity&src-id=${plannedActivity?.id}`,
//           {
//             state: {
//               item: response?.data,
//             },
//           },
//         )
//       }
//     } else {
//       togglePrewall()
//     }
//   } else {
//     toggleAppExclusiveModal()
//   }
// }
